export const ORDER_STATUS_MAPPING = {
  RECEIVED: ['received', 'order_received', 'queued', 'scheduled'],
  STARTED: ['started', 'inprogress', 'in_progress', 'preparing', 'processing'],
  READY: ['ready', 'readyforpickup', 'ready_for_pickup'],
  COMPLETED: ['retrieved', 'complete', 'completed'],
  FAILED: ['expired', 'canceled', 'cancelled', 'void', 'failed'],
} as const;

export const getOrderStep = (status: string): number => {
  const norm = status.toLowerCase().trim();

  if (
    ORDER_STATUS_MAPPING.READY.includes(norm as any) ||
    ORDER_STATUS_MAPPING.COMPLETED.includes(norm as any)
  ) {
    return 3;
  }
  if (ORDER_STATUS_MAPPING.STARTED.includes(norm as any)) {
    return 2;
  }
  if (ORDER_STATUS_MAPPING.RECEIVED.includes(norm as any)) {
    return 1;
  }
  return 1;
};

export const getOrderStatusText = (
  status: string,
  isOrderAhead: boolean,
): string => {
  const norm = status.toLowerCase().trim();

  if (
    ORDER_STATUS_MAPPING.READY.includes(norm as any) ||
    ORDER_STATUS_MAPPING.COMPLETED.includes(norm as any)
  ) {
    return 'Ready';
  }
  if (ORDER_STATUS_MAPPING.STARTED.includes(norm as any)) {
    return 'Preparing';
  }
  if (ORDER_STATUS_MAPPING.RECEIVED.includes(norm as any)) {
    return isOrderAhead ? 'Scheduled' : 'Sent to kitchen';
  }
  return isOrderAhead ? 'Scheduled' : 'Sent to kitchen';
};
